module.exports = __webpack_public_path__ + "static/media/xactly.253f79e4.png";